import { useCallback } from 'react';
import { orderBy } from 'lodash';
import { Button, Spinner } from 'reactstrap';
import { useAppSelector } from 'src/hooks/redux-hook';
import useWorkOrderAction, { ActionButtonType } from 'src/hooks/useWorkOrderAction';

const ActionButtons = () => {
  const abilities = useAppSelector((state) => state?.jobDetails?.data?.allowed_states);
  const workOrderId = useAppSelector((state) => state?.jobDetails?.data?.work_order_id);
  const hasChildJob = useAppSelector((state) => state?.jobDetails?.data?.child_job_exist);

  const { actions, loadingState } = useWorkOrderAction({
    abilities,
    workOrderId,
  });

  const handleActionButtonDisable = useCallback(
    (action: ActionButtonType) => {
      if (hasChildJob) {
        return hasChildJob;
      }
      const isAnyActionLoading = Object?.values(loadingState || {})?.some((isLoading) => isLoading);
      return action?.isDisabled || isAnyActionLoading;
    },
    [hasChildJob, loadingState],
  );

  return orderBy(actions || [], ['isDisabled'], ['asc'])?.map((action) => (
    <Button
      key={action?.slug?.[0]}
      color="deoco"
      type="button"
      className={`${action?.isDisabled ? 'disabled-button' : 'active-button'} btn btn-secondary m-1`}
      onClick={action?.onClick}
      disabled={handleActionButtonDisable(action)}
    >
      {loadingState?.[action?.slug?.[0]] ? <Spinner color="light" size="sm" className="me-2" /> : ''}

      {action?.label}
    </Button>

  ));
};

export default ActionButtons;
